import React from 'react'
import {
  BaseComponent,
} from 'belle-js'
import PropTypes from 'prop-types'
import styles from './Trustee.module.scss'
import FullAccountInformationFormGroup from 'components/Onboarding/FullAccountInformationFormGroup'
import {
  updateContact,
} from 'utils/apiRequest'

const formConfiguration = {
  PersonalInformation: { 
    hideMailingAddress: true,
  }
}

class TrusteeForm extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = { pendingContact: null }
    this.bind(
      'getTrusteeDescription',
      'addPendingContactData',
      'editPendingContactData',
      'updateContactHandler',
      'setDataHandler'
    )
  }

  getTrusteeDescription () {
    return (
      <span className={styles.pageFormDescription}>
        Enter the trustee’s information below.
      </span>
    )
  }

  addPendingContactData (data) {
    const { addContactData } = this.props
    const { contact } = data
    addContactData(data)
    const { data: { id, attributes } } = contact
    this.setState({ pendingContact: { id, ...attributes } })
  }

  editPendingContactData (data) {
    const { editContactData } = this.props
    const { contact } = data
    editContactData(data)
    const { data: { id, attributes } } = contact
    this.setState({ pendingContact: { id, ...attributes } })
  }

  async updateContactHandler (data) {
    const { contact } = this.props
    const { pendingContact } = this.state
    const contactId = contact.id || pendingContact.id

    const contactData = await updateContact(contactId, data)
    return { contact: contactData }
  }

  setDataHandler () {
    const { isAdd, editContactData } = this.props
    const { pendingContact } = this.state
    const isCreating = !pendingContact && isAdd
    let handler = editContactData

    if (isCreating) {
      handler = this.addPendingContactData
    } else if (pendingContact) {
      handler = this.editPendingContactData
    }

    return handler
  }

  render () {
    const {
      contact,
      createContactHandler,
      editFinancialAccount,
      hide,
      isAdd,
      isLoading,
      isMobile,
      returnToContactIndexPage,
      upperTitle
    } = this.props

    const { pendingContact } = this.state

    const isCreating = !pendingContact && isAdd
    const title = isAdd ? `Trustee` : `Edit Trustee`

    return (
      <FullAccountInformationFormGroup
        contact={pendingContact ? pendingContact : contact}
        editFinancialAccount={editFinancialAccount}
        formConfiguration={formConfiguration}
        formName={title}
        getDescription={this.getTrusteeDescription}
        handleFinalTab={returnToContactIndexPage}
        hide={hide}
        isLoading={isLoading}
        isMobile={isMobile}
        isProspect={false}
        setData={this.setDataHandler()}
        submitAction={isCreating ? createContactHandler : this.updateContactHandler}
        upperTitle={upperTitle} />
    )
  }

}

TrusteeForm.propTypes = {
  addContactData: PropTypes.func.isRequired,
  contact: PropTypes.object,
  createContactHandler: PropTypes.func.isRequired,
  editContactData: PropTypes.func.isRequired,
  editFinancialAccount: PropTypes.func.isRequired,
  hide: PropTypes.bool,
  isAdd: PropTypes.bool,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  returnToContactIndexPage: PropTypes.func.isRequired,
  upperTitle: PropTypes.string
}

TrusteeForm.defaultProps = {
  contact: {},
  hide: false,
  isAdd: true,
  isLoading: false,
  isMobile: false,
  upperTitle: '',
}

export default TrusteeForm



// WEBPACK FOOTER //
// ./src/components/Onboarding/TrusteeForm/index.jsx